/**
 * Maps prequalification responses to a qualification bucket.
 *
 * Per ENG-4171 — priority: zero PTZ cameras → no_cameras, no/unsure network →
 * wrong_network, else → ready. (The platform question was removed, so the
 * mobile → wrong_device branch is gone.)
 */

import { NETWORK_MATCH, PTZ_COUNT, QUALIFICATION_BUCKETS } from '../types/properties.js';
import type { PrequalificationProperties, QualificationBucket } from '../types/properties.js';

/**
 * The bucket-relevant fields. networkType is tracked in PostHog
 * but doesn't influence which bucket a user lands in.
 */
export type PrequalificationResponses = Required<
  Pick<PrequalificationProperties, 'ptzCount' | 'networkMatch'>
>;

export function computeQualificationBucket(
  responses: PrequalificationResponses
): QualificationBucket {
  // Per ENG-4171 — platform question removed; wrong_device retired.
  // ENG-4171 — zero PTZ cameras = not qualified; the count question has no
  // 'unsure' option, so '0' is the sole no_cameras trigger.
  if (responses.ptzCount === PTZ_COUNT['0']) {
    return QUALIFICATION_BUCKETS.no_cameras;
  }
  if (
    responses.networkMatch === NETWORK_MATCH.no ||
    responses.networkMatch === NETWORK_MATCH.unsure
  ) {
    return QUALIFICATION_BUCKETS.wrong_network;
  }
  return QUALIFICATION_BUCKETS.ready;
}
